:host {
    display: block;
    background-color: $color-grey-01-dark;
    padding: 32px var(--column-gap) 40px var(--column-gap);

    .headline {
        @include typo-ws-h3;

        margin: 0 0 20px;
        color: $color-white;
    }

    ::slotted(sew-ws-richtext) {
        color: $color-white;
    }

    ::slotted(sew-ws-button) {
        margin-top: 32px;
        background-color: $color-red;
        color: $color-white;
    }
}

@include mq-1 {
    :host {
        padding: 20px var(--grid-margin) 32px;
    }
}

@media print {
    :host {
        background-color: transparent;
        border: 1px solid $color-grey-03;

        .headline,
        ::slotted(sew-ws-richtext) {
            color: $color-black;
        }
    }
}

@media print {
    :host {
        ::slotted(sew-ws-button) {
            background-color: transparent;
            color: $color-black;
        }
    }
}
